import { render, staticRenderFns } from "./PageAside.vue?vue&type=template&id=3abd9a84"
import script from "./PageAside.vue?vue&type=script&lang=js"
export * from "./PageAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3abd9a84')) {
      api.createRecord('3abd9a84', component.options)
    } else {
      api.reload('3abd9a84', component.options)
    }
    module.hot.accept("./PageAside.vue?vue&type=template&id=3abd9a84", function () {
      api.rerender('3abd9a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page-aside/PageAside.vue"
export default component.exports